export default __webpack_public_path__ + "static/media/Vambraces of the Invincible.96ef89fc.jpg";